export default {
  en: {
    titles: {
      home: 'Home',
      login: 'Login',
      register: 'Register',
      profile: 'Profile',
      logout: 'Logout',
      forgot_password: 'Forgot password',
      reset: 'Reset password',
      email_verification: 'Email verification',
      update_password: 'Password change',
      update_profile: 'Profile',
      reports: 'Reports',
      calendar: 'Calendar',
      notifications: 'Notifications',
      calendar_entry: 'Calendar entry',
      create_report: 'Create Report',
      export_multi_expenses: 'Download multiple expenses reports',
      view_report: 'View Report',
      edit_report: 'Edit Report',
      report_details: 'Report Details',
      car_uses: 'Car Uses',
      edit_car_use: 'Edit Car Use',
      service_times: 'Service Times',
      edit_service_time: 'Edit Service Time',
      edit_daily_allowance: 'Edit Daily Allowance',
      total_service_time: 'Total Service Time',
      expenses: 'Expenses',
      edit_expense: 'Edit expense',
      news: 'News',
      create_news_record: 'Create news record',
      edit_news_record: 'Edit news record',
      car_owners: 'Car Owners',
      new_car: 'New Car Use',
      add_new_car: 'Add New Car',
      new_service_time: 'New Service Time',
      new_expense: 'New Expense',
      new_daily_allowance: 'New Daily Allowance',
      countries: 'Countries',
      allowances: 'Allowances',
      daily_allowances: 'Daily Allowances',
      entities: 'Entities',
      leave: 'Leave',
      leaves: 'Applications of Leave',
      create_leave: 'Create Application',
      create_leave_application: 'Create Application of Leave',
      edit_leave: 'Edit Application of Leave',
      view_news: 'View News',
      more_options: 'More options',
      selection_options: 'Selection options',
      new_allowance: 'New Allowance',
      downloads: 'Downloads',
      remark_preview: 'Remark',
      notice: 'Notice',
      poi: 'POI',
      create_poi: 'Create POI',
      edit_poi: 'Edit POI',
    },
    fields: {
      area: 'Area',
      search: 'Search',
      category: 'Category',
      remark: 'Remark',
      name: 'Name',
      first_name: 'First name',
      last_name: 'Last name',
      email: 'Email',
      password: 'Password',
      password_confirmation: 'Password confirmation',
      repeat_password: 'Repeat password',
      current_password: 'Current password',
      new_password: 'New password',
      new_password_repeat: 'Repeat new password',
      gender: 'Gender',
      dob: 'Date of birth',
      licenses: 'Licenses',
      street: 'Street',
      postal_code: 'Postal code',
      town: 'Town',
      country: 'Country',
      nationality: 'Nationality',
      bank_name: 'Bank name',
      iban: 'IBAN',
      bic: 'BIC',
      customer: 'Customer',
      vip: 'VIP',
      meeting_point: 'Meeting Point',
      job_location: 'Job Location',
      meeting_date: 'Meeting Date & Time',
      start_date_and_time: 'Start Date & Time',
      end_date_and_time: 'End Date & Time',
      type: 'Type',
      notes: 'Notes',
      car_type: 'Car Type',
      license_plate: 'License Plate (e.g. LEV KK 36)',
      license_plate_format: 'License Plate (format: LEV KK 49)',
      owner: 'Owner',
      takeover_from: 'Takeover from',
      return_to: 'Return to',
      takeover_date: 'Takeover',
      return_date: 'Return',
      km_status_takeover: 'Mileage Takeover',
      km_status_return: 'Mileage Return',
      total_km: 'Total km',
      total_time: 'Total Time',
      car_use: 'Car Use',
      date: 'Date',
      approach_start: 'Approach Start',
      approach_end: 'Approach End',
      service_start: 'Service Start',
      service_end: 'Service End',
      return_start: 'Return Start',
      return_end: 'Return End',
      idle_time: 'Idle Time',
      km_driven: 'KM driven',
      cost_type: 'Cost Type',
      amount: 'Amount (€)',
      description: 'Description',
      description_optional: 'Description (optional)',
      vip_description: 'VIP Description',
      mobile_number: 'Mobile number',
      creditor_number: 'Creditor number',
      id_card_number: 'ID card number',
      driving_license_number: 'Driving license number',
      transport_license_date: 'Exp. date passenger transport license',
      id_card: 'ID card upload',
      driving_license: 'Driving license upload',
      transport_license: 'Passenger transport license upload',
      zub: 'Registration',
      status: 'Status',
      paid: 'Paid',
      sex: {
        1: 'Male',
        2: 'Female',
        3: 'Divers',
      },
      export: 'Export',
      abroad: 'Abroad',
      allowance_type: 'Allowance type',
      meals_8: 'Verpflegung 8 < 24h',
      meals_24: 'Verpflegung 24h',
      absence_start: 'Absence Start Time',
      absence_end: 'Absence End Time',
      total_absence: 'Total absence',
      meals: 'Verpflegung',
      meal_type: 'Meal type',
      overnight_stay: 'Übernachtung',
      ride_cost: 'Fahrtkosten',
      kilometers: 'Amount of kilometers',
      start_date: 'Start Date',
      end_date: 'End Date',
      amount_of_days: 'Amount of Days',
      scan: 'Scan',
      upload: 'Upload',
      only_costs: 'Only Costs',
      export_select: 'Select to download multiple expenses reports',
      select_option: 'Select option',
      sum_service_times_select: 'Select to sum up service times',
      selection_options: 'Options',
      locations: 'Locations',
      location: 'Location',
      period: 'Period',
      city_location: 'City / Location',
    },
    table_labels: {
      id: '#',
      select: '✓',
      driver: 'Driver',
      customer: 'Customer',
      vip: 'VIP',
      meeting_point: 'Meeting point',
      meeting_date: 'Meeting date',
      actions: 'Actions',
      total_approach: 'Total Approach',
      total_service: 'Total Service',
      total_return: 'Total Return',
      status: 'Status',
      total_time: 'Total Time',
      expenses_paid: 'Expenses Paid',
      allowance_type: 'Allowance type',
      amount: 'Amount',
      report: 'Report #',
      description: 'Description',
      total_amount: 'Total amount (€)',
      date: 'Date',
      country: 'Country',
      meals: 'Verpflegung 8 < 24',
      meals_24: 'Verpflegung 24h',
      overnight_stay: 'Übernachtung',
      ride_cost: 'Fahrtkosten',
      start_date: 'Start Date',
      end_date: 'End Date',
      amount_of_days: 'Amount of Days',
      confirmed: 'Confirmed',
      total_service_time: 'Total Service Time',
      job_location: 'Job Location',
      start_date_and_time: 'Start Date & Time',
      end_date_and_time: 'End Date & Time',
      topic: 'Topic',
      license_plate: 'License Plate',
      location: 'Location',
      name: 'Name',
      expenses_uploaded: 'Exp. uploaded',
      car_type: 'Car Type',
      attachment: 'Attachment',
      city_and_location: 'City / Location',
    },
    placeholders: {
      name: 'Enter name',
      first_name: 'Enter first name',
      last_name: 'Enter last name',
      email: 'Enter email',
      password: 'Enter password',
      password_confirmation: 'Enter password confirmation',
      current_password: 'Enter current password',
      new_password_repeat: 'Repeat new password',
      description: 'Enter description',
      comment: 'Enter comment',
      date: 'Enter date',
      licenses: 'Enter licenses',
      street: 'Enter street',
      postal_code: 'Enter postal code',
      town: 'Enter town',
      country: 'Enter country',
      nationality: 'Enter nationality',
      bank_name: 'Enter bank name',
      iban: 'Enter IBAN',
      bic: 'Enter BIC',
      search: 'Start typing to search',
      customer: 'Start typing to search and select a customer',
      vip: 'Start typing to search and select VIP',
      meeting_point: 'Enter meeting point',
      location: 'Enter location',
      notes: 'Enter notes',
      car_type: 'Select Car Type',
      license_plate: 'LEV KK 49',
      owner: 'Start typing to search and select an owner',
      takeover_from: 'Takeover from',
      return_to: 'Return to',
      km_status_takeover: 'Enter kilometers',
      km_status_return: 'Enter kilometers',
      total_service_time: 'Total Service Time',
      car_use: 'Select car use',
      approach_start: 'Enter Approach Start Time',
      approach_end: 'Enter Approach End Time',
      service_start: 'Enter Service Start Time',
      service_end: 'Enter Service End Time',
      return_start: 'Enter Return Start Time',
      return_end: 'Enter Return End Time',
      idle_time: 'Enter idle time',
      km_driven: 'Enter KM driven',
      cost_type: 'Select cost type',
      amount: 'Select amount',
      vip_description: 'Enter VIP description',
      mobile_number: 'Enter mobile number',
      creditor_number: 'Enter creditor number',
      id_card_number: 'Enter ID card number',
      driving_license_number: 'Enter driving license number',
      transport_license_date: 'Enter exp. date passenger transport license',
      id_card: 'Choose ID card picture (jpeg, png, gif, pdf)',
      driving_license: 'Choose driving license picture (jpeg, png, gif, pdf)',
      transport_license: 'Choose passenger transport license (jpeg, png, gif)',
      zub: 'Choose ZUB Teil 1 (jpeg, png, gif, pdf)',
      scan: 'Choose Scan (jpeg, png, gif, pdf)',
      date_interval_start: 'Interval Start',
      date_interval_end: 'Interval End',
      allowance_type: 'Select allowance type',
      meals: 'Enter Verpflegung 8<24h',
      meals_24: 'Enter Verpflegung 24h',
      overnight_stay: 'Enter Übernachtung',
      select_country: 'Select country',
      meal_type: 'Select meal type',
      kilometers: 'Enter kilometers',
      time: 'Enter time',
      select_date: 'Select Date',
      select_amount: 'Select amount',
      enter_amount: 'Enter amount',
      license_plate_from_db: 'Select from database',
      enter_license_plate: 'Enter license plate',
      select_category: 'Select category',
      locations_multiselect: 'Filter by location',
      city_location: 'Enter city or location',
    },
    actions: {
      continue: 'Continue',
      forgot_password: 'Forgot password?',
      register_now: 'Register now',
      send_forgot_password: 'Request password change',
      submit: 'Submit',
      ok: 'OK',
      stop: 'Cancel',
      clear: 'Clear',
      export_expenses: 'Expenses pdf',
      export_report: 'Report pdf',
      export_allowances: 'Allowances pdf',
      export: 'Export',
      export_pdf: 'Export pdf',
      download: 'Download',
      remove: 'Remove',
      duplicate: 'Duplicate',
      sum: 'Sum',
      previous: 'Previous month',
      today: 'Today',
      next: 'Next month',
      open_report: 'Open report',
      open: 'Open',
      mark_read: 'Mark as read',
      mark_all_read: 'Mark all as read',
      dismiss: 'Dismiss',
      upload: 'Upload',
    },
    messages: {
      no_calendar_entries: 'No calendar entries this month.',
      scheduled_service_time: 'Scheduled Time',
      reported_service_time: 'Reported Time',
      leave_time: 'Urlaub',
      no_notifications: 'No notifications',
      forgot_password_sent: 'The recovery link has been sent to your email address.',
      password_changed: 'The password has been reset. You can log in now.',
      no_items: 'Nothing to display',
      empty_list: 'The list is empty.',
      select_category_first: 'Select category first',
      multiselect_enter: 'Enter at least 3 letters.',
      please_send: 'Please send all original receipts clearly labeled with the expense-ID (red / e.g. #149) to:',
      // own_interest: 'In your own interest, please take a copy of the documents before sending.',
      own_interest: 'In eurem eigenen Interesse bitten wir euch, eine Kopie der Belege zu machen bevor ihr sie verschickt.', // TODO fix german/english langs
      no_more_news: 'There are no more news',
      before_address:
        'Nach Abschluss des Reports die Auslagenabrechnung herunterladen, und per Email an folgende Adresse senden: expenses@kks-hahn.de',
      complete_warning:
        'Bitte füllen Sie alle roten Felder aus, um einen Report im Status „Draft“ (als Entwurf) zu speichern. Um einen Report als „Completed“ zu speichern, müssen zusätzlich auch die grünen Felder gefüllt sein.',
      please_enter_absence_times: 'Please enter absence start and absence end fields.',
      daily_allowances: 'Nach Abschluss der Eingaben die Reisekostenabrechnung herunterladen, und per Email an die Büro- oder Projektleitung senden.',
    },
    errors: {
      terms: 'You must accept the privacy policy to continue the registration.',
      period_not_legitimate_for_allowance: 'This period is not legitimate for allowance.',
      report_status_not_completed: 'Report status not completed.',
      report_status_completed_expenses_not_uploaded: 'To complete report all expenses scans must be uploaded',
      cannot_remove_zub_from_verified_car: 'You cannot remove ZUB from a verified car.'
    },
    infos: {
      area: 'Wo findet der Job statt, Inland oder Ausland (Abroad)?',
      export_daily_allowances_pdf_info: 'Download Reisekostenabrechnung pdf',
      daily_allowance_info:
        '<p class="text-center">Reisekosten können nur nach vorheriger Absprache mit der Büroleitung eingetragen & abgerechnet werden!<p><p class="text-center">Vielen Dank!</p>',
      licenses:
        'Describe your driving license and other licenses to transport passengers etc. | Beschreiben Sie Ihren Führerschein und andere Lizenzen für die Beförderung von Passagieren usw.',
      bic: 'Only necessary for accounts outside of Germany | Nur bei Konten außerhalb Deutschlands notwendig',
      meeting_point: 'Ort an dem der Einsatz beginnt',
      meeting_date: 'Start-Zeitpunkt des Einsatzes',
      meeting_notes: 'Kurze Schliderung des Auftrages, z.B.: 8:00 Uhr FH-Pickup, Fahrt ins Hotel, etc., sowie kurze Erklärung der diversen Kosten',
      takeover_from: 'Person oder Firma, die dir das Fahrzeug übergeben hat.',
      return_to: 'Person oder Firma, an die das Fahrzeug übergeben wurde.',
      takeover_date: 'Zeitpunkt der Fahrzeugübernahme',
      return_date: 'Zeitpunkt der Fahrzeugrückgabe',
      km_status_takeover: 'Kilometerstand Fahrzeugübernahme',
      km_status_return: 'Kilometerstand Fahrzeugrückgabe. Bitte bei Langzeitmieten und Transportern eintragen.',
      approach_start: 'Beginn der Anfahrt',
      approach_end: 'Ende der Anfahrt',
      service_start: 'Beginn des Fahrdienst',
      service_end: 'Ende des Fahrdienst',
      return_start: 'Beginn der Abfahrt',
      return_end: 'Ende der Abfahrt',
      idle_time: 'Idle time | Standzeit',
      km_driven: 'KM driven',
      license_plate: 'Kennzeichen',
      vip_description: 'Es muss das Feld „VIP" ODER das Feld "VIP description" ausgefüllt sein, um den Bericht zu speichern.',
      id_card_number: 'Personalausweisnummer',
      transport_license_date: 'Ablaufdatum des Personenbeförderungsschein',
      zub: 'Bitte hier ein Foto der ersten Seite des Fahrzeugscheins hochladen.',
      status: 'Draft = Bearbeitungsmodus / ' + 'Completed = Bearbeitung abgeschlossen',
      car_type: 'Fahrzeugtyp',
      car_owner: 'Fahrzeughalter',
      car_use: 'Verwendetes Fahrzeug',
      date: 'Auftragsdatum',
      cost_type: 'Auswahl der Kostenart. Bitte beachtet den Steuersatz und ob die Kosten in Deutschland oder im Ausland angefallen sind.',
      expense_date: 'Datum an dem die Kosten angefallen sind',
      amount: 'Betrag in Euro',
      amount_description: 'Kurze Erklärung der Kosten',
      export_expenses: 'Wenn diese Option deaktiviert ist, steht der Export von Ausgaben für diesen Bericht nicht zur Verfügung.',
      expenses_paid: 'Wenn Ihr ein ✔️ seht, bedeutet dies, dass alle Ausgaben erstattet wurden.',
      meals: 'Auswahl der Mahlzeiten die während der Abwesenheit geltend gemacht werden sollen',
      unsupported_meals: '<p class="text-center">Diese Eingaben führen zu einem Wert von € 0,00 und können nicht aufgenommen werden!</p>',
      leave_description: 'Nach Beendigung der Eingabe bitte den Urlaubsantrag herunterladen, und per E-Mail an die jeweilige Büroleitung schicken.',
      leave_confirmed_by: 'Confirmed by {name} at {date}',
      showing_results: '{start} - {end} of {total}',
      report_multi_expenses: 'Reports markieren um eine Auslagenabrechnung mit mehreren Reports zu erstellen',
      job_location: 'Ort des Auftrags',
      loading_notifications: 'Loading notifications...',
      empty_notifications: 'Notifications empty',
      uploading: 'Uploading...',
    },
    search: {
      by_vip_or_location: '(by VIP or Location)',
      message: '(by {entity})',
      entities: {
        customer: 'customer',
        vip: 'VIP',
        meeting_point: 'meeting point',
      },
    },
    entities: {
      report: 'Report',
      car_use: 'Car Use',
      service_time: 'Service Time',
      expense: 'Expense',
      daily_allowance: 'Daily Allowance',
      leave: 'Leave',
      download: 'Download',
      point_of_interest: 'POI',
    },
    alerts: {
      delete_entity: 'Are you sure, the you want to delete this {entity}?',
      duplicate_entity: 'Do you want to duplicate this {entity}?',
    },
    copyright: '© 2023 KKS',
    name: 'KKS',
    tos: 'Privacy Policy',
    term: 'I accept the {0} of KKS',
  },
};
